import {all, fork, put, takeEvery} from 'redux-saga/effects';
import EstService from "../../services/EstService";
import {updateCurrentUser} from "../actions/Auth";
import {SWITCH_AND_SAVE_THEME} from "../constants/Theme";

export function* switchAndSaveTheme() {
  yield takeEvery(SWITCH_AND_SAVE_THEME, function* ({currentTheme}) {
    try {
      const user = JSON.parse(localStorage.getItem('user'))
      user.dark_theme = (currentTheme === 'dark')
      localStorage.setItem('user', JSON.stringify(user))
      if(localStorage.getItem('auth_token')){
        const response = yield EstService.updateCurrentUser({dark_theme: (currentTheme === 'dark')})
        yield put(updateCurrentUser(response.data))
      }
    } catch (err) {
      console.log(err)
    }
  })
}

export default function* authSaga() {
  yield all([
    fork(switchAndSaveTheme)
  ]);
}
